// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1RfYc","resendInfoText":"OnGoingPaymentBox_resendInfoText__1AagG"};